import React from 'react';

import { getTimeStringFromSeconds } from 'js/src/libs/video-duration-tools';

const UPSELL_ICON_COLOR = '#FFA101';

const DurationOptionContent: React.FC<{ seconds: number; isLocked: boolean }> = ({
    seconds,
    isLocked,
}) => (
    <span className="d-flex align-items-center justify-content-between w-100">
        <span>{getTimeStringFromSeconds(seconds)}</span>
        {isLocked && (
            <i
                translate="no"
                className="material-symbols-outlined"
                style={{ color: UPSELL_ICON_COLOR }}
            >
                workspace_premium
            </i>
        )}
    </span>
);

export const isUserOnFreePlan = (): boolean => SERVER.USER?.plan_price <= 0;

// Cap at 60s rather than the true free plan limit to give buffer for script
// generation, which may produce scripts slightly longer than the target duration.
// This prevents free users from generating a script they can't publish.
export const MAX_FREE_DURATION_SECONDS = 60;

export const buildDurationDropdownItems = <T extends object>(
    buildOnSelectData: (seconds: number, isLocked: boolean) => T,
    activeSeconds?: number | null,
) => {
    const isFreePlan = isUserOnFreePlan();
    return Array.from({ length: 20 }, (_, i) => {
        const seconds = (i + 1) * 15;
        const isLocked = isFreePlan && seconds > MAX_FREE_DURATION_SECONDS;
        return {
            id: `duration-${seconds}`,
            text: '',
            active: activeSeconds != null ? seconds === activeSeconds : undefined,
            onSelectData: buildOnSelectData(seconds, isLocked),
            children: <DurationOptionContent seconds={seconds} isLocked={isLocked} />,
        };
    });
};
